import type {
  IOrderItem,
  QuoteRequestItem,
  SampleRequestDetail,
} from "../../types/types";
import { formatPrice } from "../../util/util-components";
import React from "react";
import { calculatePriceForQuantity } from "../../util/QuotesAndOrders";
import { TransactionItemInfoBlock } from "./TransactionItemInfoBlock";
import { makePricePerUnitString } from "./TransactionItemUtils";

type TransactionItemInfoBlockPriceProps =
  | {
      item: SampleRequestDetail;
      isSample: true;
    }
  | {
      item: QuoteRequestItem | IOrderItem;
      isSample?: false;
    };

/**
 * Shows the price details for a transaction item.
 */
export const TransactionItemInfoBlockPrice = ({
  item,
  isSample = false,
}: TransactionItemInfoBlockPriceProps) => {
  const quantity = isSample
    ? (item as SampleRequestDetail).sample_quantity
    : (item as QuoteRequestItem | IOrderItem).total_quantity;

  const totalPrice = item.price_per_unit
    ? calculatePriceForQuantity(item.price_per_unit, quantity)
    : null;

  return (
    <TransactionItemInfoBlock
      alignRight={true}
      main={totalPrice ? formatPrice(totalPrice, item.currency) : "--"}
      lines={[
        makePricePerUnitString(
          item.price_per_unit,
          item.currency,
          item.sku?.packaging_unit?.name
        ),
      ]}
    />
  );
};
